import { useContext } from "react";
import { http } from "~/services/http";
import useSWRMutation from "swr/mutation";
import { PreviewModeContext, isLiveMode } from "~/context/PreviewModeContext";

// The merged file is virus-scanned here, so this is where a rejected upload
// reports its reason. Keep the backend message so a file above the chunk
// size shows the same text as one uploaded in a single request.
const fetcher = (url, { arg }) =>
  http.postWithErrorBody(`/api/studyfile/${arg.uuid}/merge-chunks`, {
    arg: arg.formData,
  });

export const useMergeChunks = () => {
  const { mode } = useContext(PreviewModeContext);
  const isPreviewOrPrint = !isLiveMode(mode);

  const swrKey = isPreviewOrPrint ? null : "/api/studyfile/mergechunks";
  const {
    trigger: mergeChunks,
    isMutating: isMerging,
    error,
  } = useSWRMutation(swrKey, fetcher);

  if (isPreviewOrPrint) {
    return {
      mergeChunks: () => Promise.resolve(null),
      isMerging: false,
      error: null,
    };
  }

  return { mergeChunks, isMerging, error };
};
